export default class AppAsyncImage {
    constructor () {
        this.delay = 1000;
        this.max_delay = 5000;
        this.initAll();
    }

    initAll () {
        let self = this;
        $('[data-toggle=asyncimage]').each(function () {
            self.init($(this));
        });
    }

    init ($container) {
        let delay = $container.data('delay') || this.delay;
        let self = this;
        let src = $container.attr('data-src');
        if ($('[data-toggle=asyncimage][data-src="' + src + '"]').length === 0) {
            return;
        }

        if ($container.hasClass('errored')) {
            this.failed($container);
        } else if ($container.hasClass('loaded')) {
            if ($container.find('img').length === 0) {
                this.success($container);
            }
        } else if (src) {
            if (!$container.hasClass('loading')) {
                if ($container.find('i.fa-spinner').length === 0) {
                    $container.html('<i class="far fa-2x fa-spinner fa-spin text-info vertical-align-middle"></i>');
                }
                $container.addClass('loading');

                let image = new Image();
                image.onload = () => {
                    self.success($container);
                };
                image.onerror = (response) => {
                    $container.removeClass('loading');

                    if (response.status === 404) {
                        self.failed($container);
                    } else {
                        setTimeout(function () {
                            $container.data('delay', Math.min((delay + (self.delay / 2)), self.max_delay));
                            self.init($container);
                        }, delay);
                    }
                };

                const url = new URL(src, window.location.href);
                url.searchParams.set('t', new Date().getTime().toString());
                image.src = url.toString();
            }
        } else {
            this.wait($container);
        }
    }

    success ($container) {
        let self = this;
        let src = $container.attr('data-src');
        let image = new Image();
        image.onload = function () {
            $container.html('<img src="' + src + '" class="img-fluid" />');
            $container.addClass('loaded');
            $container.removeClass('loading');
        };
        image.onerror = function () {
            self.init($container);
            $container.removeClass('loading');
        };
        image.src = src;
    }

    failed ($container) {
        $container.addClass('errored');
        $container.html('<i class="far fa-2x fa-exclamation-circle text-danger vertical-align-middle"></i>');
    }

    wait ($container) {
        $container.html('<i class="far fa-2x fa-tint text-warning vertical-align-middle"></i>');
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/asyncImage.js